import $ from 'jquery';
import enquire from 'enquire.js';

let $body = $('body');

function closeAllSubPanels() {
    $('.js-dropdown-trigger').removeClass('dropdown-trigger-active');
    $('.js-dropdown-target').removeClass('dropdown-target-active');
}

function closeMegaNav() {
    closeAllSubPanels();
    $body.removeClass('mega-nav-is-open');
    $('.mega-nav-outer').slideUp('fast');
}

function closeMobile() {
    $('.nav-main').slideUp('fast');
}

$body.on('click', '.search__trigger.js-slide-toggle-trigger', function(e) {
    e.preventDefault();
    if ($body.hasClass('mega-nav-is-open')) {
        closeMobile();
        closeMegaNav();
    }
});


$body.on('click', '.js-nav-trigger', function(e) {
    e.preventDefault();
    $body.toggleClass('mega-nav-is-open');
    closeAllSubPanels();
    $('.nav-main').slideToggle('fast');
});

$body.on('click', '.js-dropdown-trigger', function(e) {
    e.preventDefault();
    e.stopPropagation();
    let $trigger = $(this);
    let $group = $trigger.closest('.js-dropdown-group');
    let isSubPanel = $group.hasClass('mega-nav__sub-panel-group');
    let target = $group.find('.js-dropdown-target')[0];


    if ($trigger.hasClass('dropdown-trigger-active')) {
        if (isSubPanel) {
            $trigger.removeClass('dropdown-trigger-active');
            $(target).removeClass('dropdown-target-active');
        }
        else {
            closeAllSubPanels();
        }

    }
    else {
        if (isSubPanel) {
            $('.mega-nav__title').removeClass('dropdown-trigger-active');
            $('.mega-nav__sub-panel').removeClass('dropdown-target-active');
        }
        else {
            closeAllSubPanels();
        }

        $body.addClass('mega-nav-is-open');
        $trigger.addClass('dropdown-trigger-active');
        $(target).addClass('dropdown-target-active');
    }

});


$body.on('click', '.js-dropdown-close', function(e) {
    e.preventDefault();
    e.stopPropagation();

    let $closeTrigger = $(this);
    let $parentTrigger = $closeTrigger.closest('.js-dropdown-group').find('.js-dropdown-trigger');
    let $target = $closeTrigger.closest('.js-dropdown-target');
    let isSubPanel = $target.hasClass('mega-nav__sub-panel');

    if (isSubPanel) {
        $target.removeClass('dropdown-target-active');
        $parentTrigger.removeClass('dropdown-trigger-active');
    }
    else {
        closeAllSubPanels();
    }


});


$(document).mouseup(function (e) {

    let container = $('.header-main__bottomNav');

    if (!container.is(e.target)
        && container.has(e.target).length === 0
        && $body.hasClass('mega-nav-is-open')
    )
    {
        closeMegaNav();

        enquire.register("screen and (max-width:860px)", {
            match : function() {
                $('.nav-top__item').each(function(){
                    $('.nav-main').slideUp('fast');
                });
            }
        });
    }
});

enquire.register("screen and (max-width:860px)", {
    match : function() {
        $('.nav-top__item').each(function(){
            $(this).appendTo('.nav-main__list');
        });
    },
    unmatch : function() {
        $('.nav-top__item').each(function(){
            $(this).appendTo('.nav-top__list');
        });
    },
});